import { render, staticRenderFns } from "./charge-details.vue?vue&type=template&id=5e96a346&scoped=true"
import script from "./charge-details.vue?vue&type=script&lang=js"
export * from "./charge-details.vue?vue&type=script&lang=js"
import style0 from "./charge-details.vue?vue&type=style&index=0&id=5e96a346&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96a346",
  null
  
)

export default component.exports